"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldShowRegulatedSpacesBanner = exports.shouldUseJumpToDate = exports.formatTimeForErrorMsg = exports.sortedVirtualSlotsByTime = exports.batchAppointmentsByDay = void 0;
const moment_1 = __importDefault(require("moment"));
const batchAppointmentsByDay = (appointments, filterBy) => {
    const batch = {};
    const isFilteredByTime = filterBy.timeOfDay.size > 0;
    const isFilteredByDay = filterBy.dayOfWeek.size > 0;
    appointments.forEach((appt) => {
        const dateKey = (0, moment_1.default)(appt.start_datetime).format('YYYY-MM-DD');
        const locKey = appt.location_id;
        if ((isFilteredByTime && !filterBy.timeOfDay.has(appt.time_of_day)) ||
            (isFilteredByDay && !filterBy.dayOfWeek.has(appt.day_of_week))) {
            return;
        }
        if (!batch[dateKey]) {
            batch[dateKey] = {};
        }
        if (!batch[dateKey][locKey]) {
            batch[dateKey][locKey] = [];
        }
        batch[dateKey][locKey].push(appt);
    });
    const sorted = Object.keys(batch)
        .map((header) => ({
        header,
        byLocId: batch[header]
    }))
        .sort((a, b) => {
        return (0, moment_1.default)(a.header).valueOf() - (0, moment_1.default)(b.header).valueOf();
    });
    return sorted;
};
exports.batchAppointmentsByDay = batchAppointmentsByDay;
const sortedVirtualSlotsByTime = (groupByLocId) => {
    const groupedData = [];
    Object.keys(groupByLocId).map((item) => {
        groupByLocId[item].map((items) => {
            groupedData.push(items);
        });
    });
    const sorted = groupedData.sort((a, b) => {
        return ((0, moment_1.default)(a.start_datetime).valueOf() - (0, moment_1.default)(b.start_datetime).valueOf());
    });
    return sorted;
};
exports.sortedVirtualSlotsByTime = sortedVirtualSlotsByTime;
const formatTimeForErrorMsg = (slotTime) => (0, moment_1.default)(slotTime).format('ddd, MMM DD - h:mm A');
exports.formatTimeForErrorMsg = formatTimeForErrorMsg;
/** Darkship feature flag for new "Jump to date" filter bar. See: https://kyruus.jira.com/browse/KENG-33104 */
const shouldUseJumpToDate = (config) => !!(config === null || config === void 0 ? void 0 : config.darkship_use_jump_to_date);
exports.shouldUseJumpToDate = shouldUseJumpToDate;
/** Feature flag to enable `Regulated Spaces` */
const shouldShowRegulatedSpacesBanner = (config) => !!(config === null || config === void 0 ? void 0 : config.show_regulated_spaces_banner);
exports.shouldShowRegulatedSpacesBanner = shouldShowRegulatedSpacesBanner;
//# sourceMappingURL=ApptList.utils.js.map